import OrganizationUserRolesIndexPage from "./OrganizationUserRolesIndexPage";
export default OrganizationUserRolesIndexPage;
